module.exports = __webpack_public_path__ + "static/matbuu-web-ef59079470e73e17e98db3c2a52075f6.jpg";